import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ReservationDetailsButton = ({ reservationId }) => {
  const navigate = useNavigate();

  if (!reservationId) {
    return null;
  }

  return (
    <Button
      onClick={() => navigate(`/reservation/${reservationId}`)}
      variant="primary"
    >
      Szczegóły rezerwacji
    </Button>
  );
};

export default ReservationDetailsButton;
